// Add a class to enable flexbox layout on purchase buttons
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.classList.add('custom-layout-enabled');
  }

  const desc = document.querySelector('.product-form--block--description');
    if (desc) {

    // 1) Remove ChatGPT UI bits
    desc.querySelectorAll('.sticky, button:has(svg.icon), svg.icon').forEach(el => el.remove());

    // 2) Remove the weird wrapper divs ChatGPT adds (classes like _tableContainer_*)
    //desc.querySelectorAll('[class*="_tableContainer_"], [class*="_tableWrapper_"]').forEach(wrapper => {
    //  // unwrap: keep children, remove wrapper
    //  while (wrapper.firstChild) wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
    //  wrapper.remove();
    //});

    // 3) Remove stray <meta charset="utf-8"> that got pasted into body copy
    desc.querySelectorAll('meta[charset]').forEach(m => m.remove());

    desc.querySelectorAll('*').forEach(el => {
      // only strip attributes we know are trash from ChatGPT
      el.removeAttribute('data-start');
      el.removeAttribute('data-end');

      // OPTIONAL: only remove data-col-size if you're sure your theme doesn't use it
      // el.removeAttribute('data-col-size');

      // OPTIONAL: only remove tabindex on the known wrapper divs, not globally
      // if (el.matches('[class*="_tableWrapper_"], [class*="_tableContainer_"]')) el.removeAttribute('tabindex');
    });
  }

});